var _dec, _dec2, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { DashboardWebAccountService } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/account/account_service';
import { computed, set } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import rpc from '@banking/api/utils/rpc';
import { v4 as uuid } from 'uuid';
import { CreateAccountRequest, DeactivateAccountRequest, ListAccountsRequest, UpdateAccountRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/dashboardweb/account/account_request_response';
import { AccountType as CommonAccountType } from '@square/dashboard-protos/models/squareup/banking/common';
let BBFrontendV1AccountService = (_dec = computed('capitalEngineContext.headers'), _dec2 = computed('accounts'), _class = class BBFrontendV1AccountService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor, this);
    _initializerDefineProperty(this, "accounts", _descriptor2, this);
  }
  getAccount(id) {
    return this.accounts.find(account => account.id === id);
  }
  addToAccounts(account) {
    this.accounts = [...this.accounts, account];
  }
  get client() {
    return DashboardWebAccountService.create(rpc((_, derivedUrl) => derivedUrl, new Map(Object.entries(this.capitalEngineContext.headers))));
  }
  get folderBalances() {
    return this.accounts.filter(account => account.type === CommonAccountType.FOLDERS_ACCOUNT);
  }
  async createAccount(args) {
    const {
      account
    } = await this.client.createAccount(CreateAccountRequest.create(args));
    if (!account) {
      throw new Error('failed to create account');
    }
    return account;
  }
  async updateAccount(id, name) {
    const {
      account
    } = await this.client.updateAccount(UpdateAccountRequest.create({
      id,
      name,
      idempotenceKey: uuid()
    }));
    if (!account) {
      throw new Error('failed to update account');
    }
    return account;
  }
  async deactivateAccount(id) {
    const {
      account
    } = await this.client.deactivateAccount(DeactivateAccountRequest.create({
      accountId: id
    }));
    if (!account) {
      throw new Error('failed to delete account');
    }
    return account;
  }
  async listAccounts(owners) {
    if (owners.length === 0) {
      throw new Error('Must provide at least one owner');
    }
    const {
      accounts
    } = await this.client.listAccounts(ListAccountsRequest.create({
      owners
    }));
    set(this, 'accounts', accounts);
    return accounts;
  }
  async retrieveAccount(accountId, owners) {
    // See if we've already fetched this account
    const existingAccount = this.getAccount(accountId);
    if (existingAccount) {
      return existingAccount;
    } else {
      await this.listAccounts(owners);
      const fetchedAccount = this.getAccount(accountId);
      if (fetchedAccount) {
        return fetchedAccount;
      } else {
        throw new Error(`Unable to retrieve account ${accountId}`);
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "accounts", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "client", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "client"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "folderBalances", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "folderBalances"), _class.prototype), _class);
export { BBFrontendV1AccountService as default };